module.exports = __webpack_public_path__ + "static/img/icon_snowflake.139f780.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons/icon_snowflake.svg
// module id = 149
// module chunks = 1 2